import {observable, action, runInAction, computed} from 'mobx'
import { get, json } from '../../../utils/ajax'
import {handleSeerchAndPage, ValueObjToObj, objToForm,setStore} from "../../../utils/Utils"

const env = process.env.REACT_APP_COMPANY

class LanguageManagerStore {

    @observable list //列表数据
    @observable pagination //分页器
    @observable loading//页面是否加载
    @observable search//查询
    @observable modal//模态框是否显示
    @observable forms//
    @observable download//对话框是否可见
    @observable languageCodeList//语言种类
    @observable doubleKeyList   //导入时重复的key
    @observable languageKeyListFuzzy  //新增修改语言时，输入中文，模糊查询结果key

    constructor() {
        this.list = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {}
        }
        this.loading = false
        this.modal = false
        this.download = 'hide'
        this.forms = {
            defaultKey: '',
            key: '',
            list: []
        }
        this.search = {
            keyOrValue: ''
        }
        this.languageCodeList = []
        this.doubleKeyList = []
        this.languageKeyListFuzzy = []
    }

    /**
     * 将页面的值绑定到store
     * @param changedFields
     */
    @action
    onSearchFieldChange=(changedFields)=>{
        this.search={...this.search,...ValueObjToObj(changedFields)}
    }


    /**
     * 语言列表 + 标题查询
     * 分页
     */
    @action
    initLanguageManagerList = async (page) => {
        runInAction(() => {
            this.loading = true
        })
        let searchResult = handleSeerchAndPage(page, this.pagination, this.search)//多条件分页的轮子
        searchResult.size = this.pagination.pageSize
        searchResult.keyOrValue = this.search.keyOrValue
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/list`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.list = res.content || []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements} 条`
            }
            this.loading = false
        })
    }

    /**
     * 设置store对象，类似react的setState
     * @param obj
     */
    @action
    setStore = (obj) => {
        setStore(obj, this)
        if (Object.prototype.toString.call(obj) === '[object Object]') {
            for (let [key, value] of Object.entries(obj)) {
                this[key] = value
            }
        }
    }

    /**
     * 获得语言编码列表
     */
    @action
    getLanguageCodeList = async () => {
        const companyId = env.companyId
        let res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/dictionary/getOneRoot`, {name: '语言/'})
        runInAction(() => {
            this.languageCodeList = res.children || []
            //去除字典表语言中的中文
            if (companyId !== 4){
                this.languageCodeList = this.languageCodeList.slice().filter((item, i) => item.code !== 'zh')
            }
        })
    }

    /**
     * 删除
     */
    @action
    deleteLanguageKey = async (key) => {
        runInAction(() => {
            this.loading = true
        })
        await json.delete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/delete/${key}`)
        runInAction(() => {
            this.loading = false
        })
        if (this.list.length === 1) {
            await this.initLanguageManagerList(this.pagination.page - 1)
        } else {
            await this.initLanguageManagerList(this.pagination.page)
        }
    }

    /**
     * 平行化表单，传值给form
     * 相当于把前台表单的数据变为后台接收数据的格式
     */
    @computed
    get fields() {
        return objToForm(this.translation())
    }

    translation = () => {
        const formField = {
            key: this.forms.key,
            list: this.forms.list
        }
        if (formField.list) {
            formField.list.forEach((a, index) => {
                formField[`id-${index}`] = a.id
                formField[`key-${index}`] = a.key
                formField[`code-${index}`] = a.code
                formField[`value-${index}`] = a.value ? a.value : ''
            })
        }
        return formField
    }

    /**
     * 将表单对象化，绑值给store
     * 相当于把对象的变化改变为表单可以接受的格式
     */
    @action
    onFormsChange = (changedFields) => {
        //变化的时候存到forms  避免再次变化时丢失第一次变化
        const formField = {...this.translation(), ...ValueObjToObj(changedFields)}
        formField.list.forEach((a, index) => {
            this.forms.list[index] = {
                id: a.id,
                code: formField[`code-${index}`],
                key: formField.key,
                value: formField[`value-${index}`] ? formField[`value-${index}`] : ''
            }
        })
        this.forms = {...this.forms, ...formField}
    }

    /**
     * 显示新增box
     */
    @action
    showAddBox = () => {
        let arr = []
        this.languageCodeList.map(i=>
            arr.push({
                id: '',
                key: this.forms.key,
                code: i.code,
                value: '',
            })
        )
        this.forms = {
            defaultKey: '',
            key: '',
            /*给list赋初始值，使得一开始就有很多个框*/
            list:arr
        }
        this.languageKeyListFuzzy=[]
        this.modal = true
    }

    /**
     * 显示修改box
     * @param key
     * @returns {Promise.<void>}
     */
    @action
    showUpdateBox = async (key) => {
        this.modal =true
        this.loading = true
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/key/${key}`)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.loading = false
            this.forms = {
                defaultKey: res[0]&&res[0].key,
                key: res[0]&&res[0].key,
                list: []
            }
            this.languageCodeList.filter(a=>a.code !== 'zh').forEach(l=>{
               let languageHasMacth=true
                res.forEach(a=>{
                    if(l.code===a.code){
                        this.forms.list.push(a)
                    languageHasMacth=false
                    }
                })
                languageHasMacth && this.forms.list.push({...res[0],...{code:l.code,value:''}})
            })
        })
    }

    /**
     * 弹出框改变中文时，根据中文模糊搜索
     * 获得key的list
     */
    @action
    getLanguageFuzzy = async (key) => {
        if(!key){
            this.forms.list.map(i=>i.value='')
            return
        }
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/get_fuzzy?key=${key}`)
        runInAction(() => {
            this.languageKeyListFuzzy = res || []
        })
    }

    /**
     * 选中key时回显数据
     */
    @action
   showSelectLanguage = async (key) => {
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/key/${key}`)
        runInAction(() => {
            this.forms = {
                defaultKey: res[0]&&res[0].key,
                key: res[0]&&res[0].key,
                list: []
            }
            this.languageCodeList.filter(a=>a.code !== 'zh').forEach(l=>{
                let languageHasMacth=true
                res.forEach(a=>{
                    if(l.code===a.code){
                        this.forms.list.push(a)
                        languageHasMacth=false
                    }
                })
                languageHasMacth && this.forms.list.push({...res[0],...{code:l.code,value:''}})
            })
            this.modal = true
        })
    }


    /**
     * 修改--添加一条翻译
     * 添加一条已知key,其他为空的数据到forms
     * @returns {Promise.<void>}
     */
    addLanguage = async () => {
        //const restCode = this.languageCodeList.list.slice()
        runInAction(() => {
            this.forms.list.push({
                id: '',
                code: '',
                key: '',
                value: ''
            })
        })
    }

    /**
     * 删除动态语言单框
     */
    @action.bound
    deleteLanguage = async (index) => {
        runInAction(() => {
            runInAction(() => {
                this.loading = true
                this.forms.list = this.forms.list.slice().filter((item, i) => i !== index)
                this.loading = false
            })
        })
    }

    /**
     * 关闭Box
     */
    @action
    closeBox = () => {
        runInAction(() => {
            this.modal =false
            this.forms.list = []
        })
    }

    /**
     *清空search的input框值
     */
    @action clear = () => {
        runInAction(() => {
            this.search = {}
            this.initLanguageManagerList()
        })
    }

    /**
     * 确定--保存修改
     *
     */
    @action saveUpdate = async () => {
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/update/${this.forms.defaultKey}`, this.forms.list)
        runInAction(() => {
            this.modal = false
            this.loading = false
        })
        this.initLanguageManagerList()
    }

    /**
     * 确定--保存新增语言
     *
     */
    @action saveAdd = async () => {
        this.loading = true
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/add`, this.forms.list)
        runInAction(() => {
            this.modal = false
            this.loading = false
        })
        this.initLanguageManagerList()
    }

    /**
     * 设置导出url
     * 导出全部
     */
    getUrl = () => {
        const url = `${process.env.REACT_APP_API_URL}/onestep/base/customerService/language/export/excel`
        // return `${url}?${_encodeParam()}`
        return `${url}`
    }
}

export default new LanguageManagerStore()



// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/LanguageManager/store.js